import { useState, useRef, useEffect } from 'react'

export const useObserveElementWidth = <T extends HTMLElement>() => {
    const [width, setWidth] = useState(0)
    const ref = useRef<T>(null)

    useEffect(() => {
        const observerRefValue = ref.current
        const observer = new ResizeObserver((entries) => {
            setWidth(entries[0].contentRect.width)
        })

        if (observerRefValue) {
            observer.observe(observerRefValue)
        }

        return () => {
            observerRefValue && observer.unobserve(observerRefValue)
        }
    }, [])

    return { width, ref }
}
